module.exports = __webpack_public_path__ + "static/media/icon-medal.e5dc44e9.png";